/* eslint-disable @typescript-eslint/strict-boolean-expressions */
import * as PropTypes from 'prop-types';
interface SymbolProps {
  img?: string;
  initials?: string;
}

const Symbol: React.FC<SymbolProps> = ({ img, initials }) => {
  if (!img && !initials)
    return (
      <div className="symbol symbol-40px user-select-none">
        <div className="symbol-label fs-2 fw-semibold text-success">?</div>
      </div>
    );
  if (img)
    return (
      <div className="symbol symbol-40px user-select-none">
        <img src={img} alt="" />
      </div>
    );
  if (initials)
    return (
      <div className="symbol symbol-40px user-select-none">
        <div className="symbol-label fs-2 fw-semibold text-success">
          {initials}
        </div>
      </div>
    );
  return null;
};

export default Symbol;
Symbol.propTypes = {
  img: PropTypes.string,
  initials: PropTypes.string
};
